async function fetchCancelationInsurance({ uid }) {
  const API = `https://us-central1-auto-clupp.cloudfunctions.net/cluppAPIV1/v1/users/${uid}/cancel-insurance`;

  try {
    const response = await fetch(API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmdhbml6YXRpb24iOiJSQVNUUkVBVE9SIn0.OGp_G6Lref09-YkoRsY3vBUEndMpAbhUR-tHHu-nlm4",
      },
    });

    if (!response.ok) {
      console.log(
        "[Error canceling Insurance]",
        response.status,
        response.statusText
      );
      throw new Error("Failed in to cancel insurance");
    }

    const json = await response.json();
    return json;
  } catch (error) {
    console.log("[Error canceling Insurance]", error);
    throw new Error("[Error canceling Insurance]");
  }
}

export default fetchCancelationInsurance;
